import { DEFAULT_RATE } from "./constants";

// Elements: every [data-*] hook inside this player, looked up once.
export function queryElements(root) {
    const q = sel => root.querySelector(sel);
    const qa = sel => Array.from(root.querySelectorAll(sel));

    return {
        currentTime: q("[data-current-time]"),
        duration: q("[data-duration]"),
        progress: q("[data-progress]"),
        fill: q("[data-progress-fill]"),
        previewAnchor: q("[data-preview-anchor]"),
        previewLabel: q("[data-preview-label]"),
        previewTime: q("[data-preview-time]"),
        thumbAnchor: q("[data-thumb-anchor]"),
        thumb: q("[data-thumb]"),
        seek: q("[data-seek]"),
        speedTrigger: q("[data-speed-trigger]"),
        speedList: q("[data-speed-list]"),
        speedOptions: qa("[data-rate]"),
        skips: qa("[data-skip]"),
        play: q("[data-play]"),
        spinner: q("[data-spinner]"),
        mute: q("[data-mute]"),
        volume: q("[data-volume]"),
        volumeFill: q("[data-volume-fill]"),
        volumeThumb: q("[data-volume-thumb]"),
        info: q("[data-info]"),
        error: q("[data-error]"),
        retry: q("[data-retry]"),
        caption: q("[data-caption]")
    };
}

// Config: fixed settings from the template's data-* attributes on the player root.
export function readConfig(root) {
    const d = root.dataset;
    return {
        name: d.audioName || "",
        skip: Number(d.skipSeconds) || 10,
        rates: (d.rates || "")
            .split(",")
            .map(Number)
            .filter(Number.isFinite),
        labels: {
            play: d.labelPlay,
            pause: d.labelPause,
            mute: d.labelMute,
            unmute: d.labelUnmute,
            speed: d.labelPlaybackSpeed,
            seekValue: d.labelSeekValue
        }
    };
}

// State: what changes during playback. Handlers update it, then call render().
export function createState() {
    return {
        isPlaying: false,
        currentTime: 0,
        duration: 0,
        volume: 1,
        isMuted: false,
        playbackRate: DEFAULT_RATE,
        isBuffering: false,
        hasError: false,
        scrubTime: null,
        hoverTime: null,
        isDragging: false,
        isFocused: false,
        isHovered: false,
        menuOpen: false,
        activeOption: -1
    };
}
